<style lang="scss" scoped>
.leftnav {
  float: left;
  width: 200px;
}
.container{
  position: relative;
}
#TopNav {
  	padding: 0 40px;
  	box-sizing:border-box;
		min-height: 56px;
		width: 100%;
		background-color: #fff;
		box-shadow: 1px 2px 10px rgba(0, 0, 0, .1);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1999;
  	.logo, .home-menu, .version, .account {
	  height: 56px;
	  line-height: 56px;
	}
	.logo{
	  padding-top: 10px;
	  cursor: pointer;
	  svg {
	    width: 90px;
	    height: 50px;
	    position: relative;
	    top: -7px;
	    &.beta-icon{
	      width: 25px;
	      height: 24px;
	      top: -35px;
	    }
	  }
	}
}
</style>
<template>
<div>
  <div class="main">
    <router-view></router-view>
  </div>
  <div class="topnav">
    <AiTopNav v-if="true || user && user.userId"
    :route='$route'
    :account="account"
    :searchShow="true"
    :user='user'
    :company='company'
    :wo='wo'
    ></AiTopNav>
    <div v-else>
      <div id="TopNav" >
        <a class="logo float_left" href="/">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-duilogo"></use>
          </svg>
          <svg class="icon beta-icon" aria-hidden="true">
            <use xlink:href="#icon-beta"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapState,
  mapActions
} from 'vuex'
import AiTopNav from './components/AiTopNav'

export default {
  created () {
    this.REMEMBER_SIGNIN({
      // productKey:this.product.productinfo.productKey
    })
  },
  components: {
    AiTopNav: AiTopNav.AiTopNav
  },
  data () {
    return {
      searchShow:true,
      menuList:[],
      scrollBody: '',
      actionUrl:'https://t.dui.ai/console/api/v1.0/track/upload',
      hrefList:[{
        url:'/docs/ct_skill', describe:'如何创建技能？'
      }, {
        url:'/docs/product_player', describe:'如何创建产品？'
      }, {
        url:'/docs/ct_faq', describe:'常见问题'
      }]
    }
  },
  computed: {
    ...mapState(['user', 'wo', 'company', 'account']),
    showAdviceDialog:{
      get(){
        return this.wo.adviceDialog
      },
      set(val){
        this.adviceDialogChange(val);
      }
    }
  },
  methods: {
    ...mapActions(['REMEMBER_SIGNIN']),
  }
}
</script>



// WEBPACK FOOTER //
// app.vue?1c58969e